import LovedIcon from "../assets/images/loved_icon.svg";
import DashboardIcon from "../assets/images/dashboard_icon.svg";
import BigLogo from "../assets/images/big_logo.png";
import UserLogo from "../assets/images/user_icon.svg";

export default function Sidebar({ module, toogleClicked }) {
  return (
    <aside class="sidebar">
      <div class="text-center w-100">
        <a href="javascript:void(0);" class="logo">
          <img src={BigLogo} alt="logo" />
        </a>
      </div>
      <h3>BigPurplePhone Admin Panel</h3>
      <ul class="leftBarMenu">
        {/* <li>
          <a href="#">
            <img src={DashboardIcon} alt="" /> Dashboard
          </a>
        </li> */}
        <li className={module == "lovedone" ? "active" : ""}>
          <a href="/lovedone/list">
            <img src={LovedIcon} alt="" /> Loved One's
          </a>
        </li>
        <li className={module == "user" ? "active" : ""}>
          <a href="/user/list">
            <img src={UserLogo} alt="" /> Users
          </a>
        </li>
        {/* <li>
          <a href="users.html">
            <img src={UserLogo} alt="" /> Export All
          </a>
        </li>
        <li>
          <a href="users.html">
            <img src={UserLogo} alt="" /> Archived Records
          </a>
        </li> */}
      </ul>
    </aside>
  );
}
